import React, { Fragment, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { ImageUploader, TextField } from "components"
import OdpdFooter from "./OdpdFooter"
import classes from "./index.module.scss"

const initialFormState = {
  paymentAttachUrls: [],
  paymentNote: ""
}

const OrderDetailsPaymentDetails = props => {
  const { order, setOrders } = props

  const [t] = useTranslation()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const [enableEdit, setEnableEdit] = useState(false)
  const [form, setForm] = useState(initialFormState)

  const handleChangePaymentNote = (e) => {
    const value = e.target.value

    setForm(prev => ({
      ...prev,
      paymentNote: value
    }))
  }

  const handleAddUrl = (urls) => {
    setForm(prev => ({
      ...prev,
      paymentAttachUrls: [...prev.paymentAttachUrls, ...urls]
    }))
  }

  const handleRemoveUrl = (url) => {
    setForm(prev => ({
      ...prev,
      paymentAttachUrls:
        prev.paymentAttachUrls.filter(pau => pau !== url)
    }))
  }

  useEffect(() => {
    order.orderStatus !== "pending" &&
      setEnableEdit(false)
  }, [order.orderStatus])

  const showEditButton =
    order.orderStatus === "pending"

  const showOrderNote =
    order.paymentNote && !enableEdit

  const showPaymentAttachUrls =
    !enableEdit &&
    order.paymentAttachUrls?.length > 0

  const hide =
    !order.paymentNote &&
    order.orderStatus !== "pending" &&
    !order.paymentAttachUrls?.length

  if (hide) return null

  return (
    <div className={classes["container"]}>
      <div className={classes["title"]}>
        {t("جزئیات_پرداخت")}
      </div>

      {
        showOrderNote &&
        <div className={classes["payment-details"]}>
          <span className={classes["subtitle"]}>
            {t("یادداشت")}:
          </span>
          <div className={classes["note"]}>
            {order.paymentNote}
          </div>
        </div>
      }

      {
        showPaymentAttachUrls &&
        <Fragment>
          <span className={classes["subtitle"]}>
            {t("پیوست")}:
          </span>
          <ImageUploader
            readOnly
            isDeletable={false}
            accountId={accountId}
            imageCategory="payment"
            values={order.paymentAttachUrls}
          />
        </Fragment>
      }

      {
        enableEdit &&
        <TextField
          label={t("یادداشت")}
          componentClass="textarea"
          maxLength={300}
          value={form.paymentNote}
          className={classes["input-container"]}
          inputClassName={classes["input"]}
          onChange={handleChangePaymentNote}
        />
      }

      {
        enableEdit &&
        <Fragment>
          <span className={classes["subtitle"]}>
            {t("پیوست")}:
          </span>
          <ImageUploader
            isDeletable
            accountId={accountId}
            imageCategory="payment"
            readOnly={!enableEdit}
            enableCrop={false}
            maxNumberOfUploads={5}
            onAdded={handleAddUrl}
            onRemoved={handleRemoveUrl}
            values={form.paymentAttachUrls}
          />
        </Fragment>
      }

      {
        showEditButton &&
        <OdpdFooter
          form={form}
          setForm={setForm}
          order={order}
          setOrders={setOrders}
          enableEdit={enableEdit}
          setEnableEdit={setEnableEdit}
        />
      }
    </div>
  )
}

export default OrderDetailsPaymentDetails